import { TableColumnsType } from 'antd';
import dayjs from '/react4xp/mixins/dayjsConfig';
import { localize } from '/react4xp/mixins/helpers';

export const columns = (translations: Record<string, string>): TableColumnsType => [
    {
        title: localize('iin-bin', translations),
        dataIndex: 'iinBin',
        key: 'iinBin',
    },
    {
        title: localize('find-liquidated-full-name', translations),
        dataIndex: 'name',
        key: 'name',
    },
    {
        title: localize('ovd-type', translations),
        dataIndex: 'ovdType',
        key: 'ovdType',
    },
    {
        title: localize('activity-type', translations),
        dataIndex: 'activityType',
        key: 'activityType',
    },
    {
        title: localize('object-address', translations),
        dataIndex: 'address',
        key: 'address',
    },
    {
        title: localize('find-liquidated-begin-date', translations),
        dataIndex: 'beginDate',
        key: 'beginDate',
        render: (a) => a ? dayjs(a).format('DD.MM.YYYY') : '',
    },
    {
        title: localize('find-liquidated-end-date', translations),
        dataIndex: 'endDate',
        key: 'endDate',
        render: (a) => a ? dayjs(a).format('DD.MM.YYYY') : '',
    },
];